/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Container } from "@mui/material";
import BarraNavegacion from "src/layouts/layout-privado/barra-navegacion/BarraNavegacion";
import { useAppSelector } from "src/redux/store";
import { Roles } from "src/utils/roles/roles";
import Breadcrumb from "./breadcrumb/Breadcrumb";
import Sidebar from "./sidebar/Sidebar";

/* eslint-disable react/react-in-jsx-scope */
export type LayoutPrivadoProps = {
  children: React.ReactNode;
};

function LayoutPrivado({ children }: LayoutPrivadoProps) {
  const menu = useAppSelector((estadoApp) => estadoApp?.usuario?.menu ?? []);
  
  const menuLateral = useAppSelector(
    (estadoApp) => estadoApp?.usuario?.menuLateral ?? [],
  );
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", height: "100vh" }}
      data-testid="layout-privado"
    >
      <Box sx={{ display: "flex", flexGrow: 1, overflowY: "hidden" }}>
        <Sidebar menuItems={menuLateral} />
        <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
          <BarraNavegacion menu={menu} />
          <Breadcrumb />
          <Box component="main" sx={{ padding: 2 }}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default LayoutPrivado;
